import React from 'react';
import { Button,  makeStyles, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';


const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: '16px',
    borderRadius: "5px",
    boxSizing: "border-box",
    cursor: "pointer",
    display: "inline-block",
    lineHeight: "28px",
    maxWidth: "100%",
    minHeight: "40px",
    minWidth: "160px",
    outline: "0px",
    padding: "5px",
    position: "relative",
    textAlign: "center",
    textDecoration: "none",
    transitionDuration: "0.25s",
    fontWeight: "600 !important",
  },
  noShadow: {
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  noTransform: {
    textTransform: 'none',
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: 'rgb(255, 68, 79)',
    },
  },
  secondary: {
    color: 'rgb(98, 100, 104)',
    borderColor: theme.palette.secondary.main,
    border: '1px solid rgb(98, 100, 104)',
    '&:hover': {
        background: 'rgb(137, 139, 142)',
        color: 'rgb(255, 255, 255)',
    },
  },
  loadingSpinner: {
    marginRight: theme.spacing(1),
  },
}));

const CustomButton = ({ 
    variant, 
    children, 
    hasBoxShadow = false, 
    hasTransform = false, 
    isLoading = false,
    loadingText,
    isDisabled = false,
    ...props 
}) => {
  const classes = useStyles();

  return (
    <Button
        className={`${classes.root} ${classes[variant]} ${!hasBoxShadow ? classes.noShadow : ''} ${!hasTransform ? classes.noTransform : ''}`}
        variant={variant === 'primary' ? 'contained' : 'outlined'}
        color={variant}
        disabled={isDisabled || isLoading}
        {...props}
    >
        {isLoading && <CircularProgress size={20} className={classes.loadingSpinner} />}
        {isLoading && loadingText ? loadingText : children}
    </Button>
  );
};

CustomButton.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  children: PropTypes.node.isRequired,
  hasBoxShadow: PropTypes.bool,
  hasTransform: PropTypes.bool,
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default CustomButton;